
<template>
    <div class="wang_box">
        <div style="border: 1px solid #ccc">
            <Toolbar style="border-bottom: 1px solid #ccc" :editor="editor" :defaultConfig="toolbarConfig" :mode="mode" />
            <Editor style="height: 600px; overflow-y: hidden" v-model="centerEditor" :defaultConfig="editorConfig" :mode="mode" @onCreated="onCreated" @onFocus='randSetwx' @onBlur='randSetwx' />
        </div>

        <div class="dialbox">
            <div style="width: 100%;">
                <el-form label-width="100px" class="demo-ruleForm" style="padding-top:5px;">
                    <el-form-item label="APPID" prop="weappId" style="padding-top:5px;">
                        <input type="text" style="width: 200px" id='wxappid' class="elInputupl" value="" />
                    </el-form-item>

                    <el-form-item label="访问路径" prop="smallRouter" style="padding-top:5px;">
                        <!-- <el-input style="width: 200px" id='wxpath'></el-input> -->
                        <input type="text" style="width: 200px" id='wxpath' class="elInputupl" value="" />
                    </el-form-item>

                    <el-form-item label="上传图片">
                        <el-upload class="upload-demo" :headers="headers" :action="uploadImgUrl" name="file" :on-success="handleUploadSuccess" :before-upload="handleBeforeUpload" :on-error="handleUploadError" :show-file-list="false" accept="image/*">
                            <el-button type="primary" size="small" class="elcobut">点击上传</el-button>
                        </el-upload>

                        <!-- 上传图片展示 -->
                        <!-- <el-image v-show="ruleForm.weappImgUrl && ruleForm.methodStatus == 1" style="width: 200px; height: 200px;margin-top:30px;" id="elImage" :src="ruleForm.weappImgUrl" :preview-src-list="[ruleForm.weappImgUrl]" :z-index="10010">
                        </el-image> -->
                        <img src="" style="display:none; width: 200px; height: 200px;margin-top:30px;" id="elImage" alt="">

                    </el-form-item>
                </el-form>
                <div class="bon_btn">
                    <el-button id='disnone' @click="cancelForm">取 消</el-button>
                    <el-button type="primary" @click="setSmallRoutine">确定</el-button>
                </div>

            </div>
        </div>
        <div class="dial_bg"></div>

        <!-- <el-dialog title="小程序链接" :visible.sync="dialogVisible" width="40%" @close='wxclose' id='wxdialog'>
            <div style="width: 100%; display: flex; align-items: center">
                <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item label="APPID" prop="weappId">
                        <el-input v-model="ruleForm.weappId" style="width: 200px"></el-input>
                    </el-form-item>

                    <el-form-item label="访问路径" prop="smallRouter">
                        <el-input v-model="ruleForm.smallRouter" style="width: 200px"></el-input>
                    </el-form-item>

                    <el-form-item label="展示方式" prop="methodStatus">
                        <el-radio-group v-model="ruleForm.methodStatus" style="width: 200px">
                         
                            <el-radio :label="1">图片</el-radio>
                          
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label="文字内容" prop="textValue" v-if="ruleForm.methodStatus == 0">
                        <el-input v-model="ruleForm.textValue" maxlength="100" style="width: 300px"></el-input>
                    </el-form-item>

                    <el-form-item label="卡片标题" prop="cardTitle" v-if="ruleForm.methodStatus == 2">
                        <el-input v-model="ruleForm.cardTitle" maxlength="100" style="width: 300px"></el-input>
                    </el-form-item>

                    <el-form-item :label="ruleForm.methodStatus == 1 ? '上传图片' : '卡片封面'" prop="textValue" v-if="ruleForm.methodStatus != 0">

                        <el-upload class="upload-demo" :headers="headers" :action="uploadImgUrl" name="file" :on-success="handleUploadSuccess" :before-upload="handleBeforeUpload" :on-error="handleUploadError" :show-file-list="false" accept="image/*">
                            <el-button type="primary" size="small" class="elcobut">添加图片</el-button>
                        </el-upload>

                     
                        <el-image v-if="ruleForm.weappImgUrl && ruleForm.methodStatus == 1" style="width: 200px; height: 200px;margin-top:30px;" :src="ruleForm.weappImgUrl" :preview-src-list="[ruleForm.weappImgUrl]" :z-index="10010">
                        </el-image>

                    
                        <el-image v-if="ruleForm.weappCoverImgUrl && ruleForm.methodStatus == 2" style="width: 200px; height: 200px" :src="ruleForm.weappImgUrl" :preview-src-list="[ruleForm.weappImgUrl]" :z-index="10010">
                        </el-image>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="setSmallRoutine">确定</el-button>
            </span>
        </el-dialog> -->
    </div>
</template>

<script>
import { IMAGE_UPLOAD_OSS_URL } from '@/common/const.js';
import { Editor, Toolbar } from '@wangeditor/editor-for-vue';
import { Boot } from '@wangeditor/editor';

/**
 * 注：
 * 编辑器自定义的方法和监听功能无法和vue进行数据通讯，
 * 这里使用jQuery操作dom元素的方案来解决
 */

export default {
    name: 'wangEditor',
    props: {
        content: {
            type: String,
            default: '',
        }
    },
    data() {
        return {
            editor: null,
            centerEditor: '',
            toolbarConfig: {},
            editorConfig: {
                MENU_CONF: {
                    uploadImage: {
                        customUpload: this.update
                    }
                },
                hoverbarKeys: {
                    'image': {
                        // 重写 link 元素的 hoverbar
                        menuKeys: ['imageWidth30', 'imageWidth50', 'imageWidth100', 'viewImageLink', 'deleteImage'],
                    },
                }
            },
            mode: 'default', // or 'simple'

            // 以下是自定义方法用到的参数
            uploadImgUrl: IMAGE_UPLOAD_OSS_URL, // 上传的图片服务器地址
            headers: {
                Authorization: localStorage.getItem('middle-token')
            },
            dialogVisible: false,
            ruleForm: {
                weappId: null, // 小程序appid
                textValue: '', // 文字内容
                smallRouter: '', // 小程序路径
                weappImgUrl: '', // 上传图片路径
                weappCoverImgUrl: '', // 上传封面
                cardTitle: '', // 卡片标题
                methodStatus: 1 // 展示方式 0：文字， 1：图片 2： 卡片
            },
            isAppId: false,

            MyModalMenu: null,

        }
    },

    watch: {
        centerEditor(val) {
            // console.log(val)
            this.$emit('update:content', val);
            // 延迟渲染小程序图标，避免样式被编辑器重置
            // this.editor.setHtml(val);
            setTimeout(() => {

                this.randSetwx();
            }, 500);
        },

        content(val) {
            this.centerEditor = val;
        },
        dialogVisible(val) {
            console.log(val, '发生改变')
        }
    },

    components: { Editor, Toolbar },
    created() { },
    beforeDestroy() {
        if (this.editor == null) return;
        this.editorConfig.onchange = null
        this.editor.destroy(); // 组件销毁时，及时销毁编辑器
        this.editor = null;

        console.log('销毁编辑器')
    },
    methods: {
        onCreated(editor) {
            // console.log(editor, '创建editor')
            this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
            // console.log(this.editor.getAllMenuKeys(), 'key')
            this.weixinImgUpload();
        },

        // 自定义上传
        update(file, insertFn) {
            console.log(file, insertFn);
            // file 即选中的文件
            // 自己实现上传，并得到图片 url alt href
            let formData = new FormData();
            formData.append('file', file);

            // 图片上传
            fetch(IMAGE_UPLOAD_OSS_URL, {
                method: 'post',
                // headers: {
                //     'Content-Type': 'application/json'
                // },
                body: formData
            }).then((response) => response.json()).then((res) => {
                // console.log(res, '上传成功');
                // 上传成功的图片插入编辑器中
                insertFn(res.data.uri, file.name, res.data.uri);
            });
        },

        // 自定义一个小程序图片上传方法
        weixinImgUpload() {
            let _that = this;
            console.log(this, '前')
            class MyModalMenu {
                constructor() {
                    this.title = '小程序'; // 自定义菜单标题
                    // this.iconSvg = "<svg>...</svg>" // 可选
                    this.tag = 'button';
                }
                // 菜单是否需要激活（如选中加粗文本，“加粗”菜单会激活），用不到则返回 false
                isActive(editor) {
                    return false;
                }

                // 获取菜单执行时的 value ，用不到则返回空 字符串或 false
                getValue(editor) {
                    return '';
                }

                // 菜单是否需要禁用（如选中 H1 ，“引用”菜单被禁用），用不到则返回 false
                isDisabled(editor) {
                    return false;
                }

                // 点击菜单时触发的函数
                exec(editor, value) {
                    // console.log(editor.menus.get('bold').type, '按钮类型')
                    // console.log(_that.dialogVisible, 'dialogVisible')
                    // alert(_that.dialogVisible)
                    // console.log(_that.editor, _that, 'edirot对象')
                    // console.log(editor.getFragment(), '选中');

                    $('.dialbox').css('display', 'block');
                    $('.dial_bg').css('display', 'block');
                    let emt = editor.getFragment();
                    if (emt.length > 0 && emt[0].children[0].hasOwnProperty('type')) {
                        if (emt[0].children[0].type == 'image') {
                            if (emt[0].children[0].href.includes('data-miniprogram-appid')) {
                                console.log('选中编辑，并且有appid')
                                let src = emt[0].children[0].href.slice(1, emt[0].children[0].href.length - 1)
                                let srcArr = src.split(',');
                                let dataWx = {};
                                srcArr.forEach(item => {
                                    let arr = item.split(':');
                                    dataWx[`${arr[0]}`] = arr[1];
                                })
                                $('#wxappid').val(dataWx['data-miniprogram-appid']);
                                $('#wxpath').val(dataWx['data-miniprogram-path']);
                                $("#elImage").attr("src", emt[0].children[0].src);
                                $('#elImage').css('display', 'block');

                                // 做标记，后续用来判断是新增还是编辑小程序链接
                                $('.dialbox').attr('isappid', 'true');

                            } else {
                                // console.log('选中编辑，没有appid')

                                $('.dialbox').attr('isappid', 'false');
                            }
                        }
                    } else {
                        // console.log('新增编辑，没有appid')
                        _that.isAppId = false;
                        $('.dialbox').attr('isappid', 'false');
                    }

                }
            }

            // 工具栏按钮
            const WEXin = {
                key: 'weixin', // 定义 menu key ：要保证唯一、不重复（重要）
                factory() {
                    return new MyModalMenu(); // 把 `YourMenuClass` 替换为你菜单的 class
                }
            };

            let keyArr = this.editor.getAllMenuKeys();
            // console.log(keyArr, keyArr.includes('weixin'), 'key')

            if (!keyArr.includes('weixin')) {
                Boot.registerMenu(WEXin);
            }
            this.editorConfig.hoverbarKeys['image'].menuKeys.push('weixin');
            this.toolbarConfig.insertKeys = { index: 5, keys: ['weixin'] };

        },

        //取消按钮
        cancelForm() {
            $('.dialbox').css('display', 'none');
            $('.dial_bg').css('display', 'none');
            $('#elImage').css('display', 'none');
            $('#wxappid').val('');
            $('#wxpath').val('');
            $("#elImage").attr("src", '');
        },


        // 确定添加
        setSmallRoutine() {

            let text = '';
            let html = this.editor.getHtml();
            console.log(html, '获取到的内容');

            // if (this.ruleForm.methodStatus == 0) {//文字暂不考虑，会和a标签冲突
            //     // 若是文字类型   则渲染a标签中添加文字
            //     text = `<a class="weapp_text_link js_weapp_entry"  style="font-size:medium;" data-miniprogram-appid="${this.ruleForm.weappId}" data-miniprogram-path="${this.ruleForm.smallRouter}" data-miniprogram-nickname="鲤好惠选" href="" data-miniprogram-type="text" data-miniprogram-servicetype="">${this.ruleForm.textValue}</a>`;
            // }

            let imgurl = $('#elImage').attr('src');
            let appid = $('#wxappid').val();
            let wxpath = $('#wxpath').val();
            let isappid = $('.dialbox').attr('isappid');


            if (!appid) {
                this.$message.warning('请输入小程序APPID');
                return false;
            }
            if (!wxpath) {
                this.$message.warning('请输入小程序访问路径');
                return false;
            }
            if (!imgurl) {
                this.$message.warning('请上传小程序链接图片');
                return false;
            }

            text = `<img src="${imgurl}" class='weapp_image_link' data-href="{data-miniprogram-appid:${appid},data-miniprogram-path:${wxpath}}" />`;

            console.log(text, '富文本内容')


            this.editor.restoreSelection();

            if (JSON.parse(isappid)) {
                this.editor.deleteBackward();
            }
            this.editor.dangerouslyInsertHtml(text);

            $('.dialbox').css('display', 'none');
            $('.dial_bg').css('display', 'none');
            $('#elImage').css('display', 'none');
            $('#wxappid').val('');
            $('#wxpath').val('');
            $("#elImage").attr("src", '');

            this.$nextTick(() => {
                this.randSetwx();
            })
        },

        // 渲染小程序图标
        randSetwx() {
            let imgList = document.querySelectorAll('img');
            // console.log(imgList, 'imglist获得焦点or失去焦点')

            imgList.forEach(item => {
                let path = item.getAttribute('data-href');
                if (path && path.includes('data-miniprogram-appid')) {
                    item.parentNode.classList.add("weapp_image_link");
                }
            })
        },

        wxclose() {
            this.ruleForm = {
                weappId: null, // 小程序appid
                textValue: '', // 文字内容
                smallRouter: '', // 小程序路径
                weappImgUrl: '', // 上传图片路径
                weappCoverImgUrl: '', // 上传封面
                cardTitle: '', // 卡片标题
                methodStatus: 1 // 展示方式 0：文字， 1：图片 2： 卡片
            }
        },


        handleUploadSuccess(res) {
            this.loading.close();
            console.log(res, 'img');
            this.ruleForm.weappImgUrl = res.data.uri;
            $('#elImage').attr('src', res.data.uri);
            $('#elImage').css('display', 'block');
        },
        handleBeforeUpload() {
            this.loading = this.$loading({
                lock: true,
                text: '上传中',
                background: 'rgba(0, 0, 0, 0.7)'
            });
        },
        handleUploadError() {
            this.$message({
                type: 'error',
                message: '上传失败'
            });
            this.loading.close();
        }

    },
}


</script>

<style scoped lang='scss'>
.wang_box {
    &::v-deep .weapp_image_link {
        position: relative;
        &::after {
            content: '';
            width: 26px;
            height: 26px;
            position: absolute;
            background-color: red;
            right: 20px;
            top: 20px;
            background: url(data:image/png;base64,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)
                no-repeat center;
            background-size: contain;
        }
    }
}

.el-upload-list {
    display: none !important;
}
.dialbox {
    position: fixed;
    display: none;
    width: 800px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 200;
    background-color: #fff;
    padding: 30px;
    border-radius: 20px;
}
.dial_bg {
    display: none;
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    z-index: 150;
    background: rgba(0, 0, 0, 0.5);
}
.bon_btn {
    display: flex;
    width: 100%;
    justify-content: flex-end;
}
.elInputupl {
    width: 200px;
    height: 32px;
    padding: 0 5px;
}
</style>
<style src="@wangeditor/editor/dist/css/style.css"></style>
